import { render, staticRenderFns } from "./OccasionFilter.vue?vue&type=template&id=3e493f57&scoped=true&"
import script from "./OccasionFilter.vue?vue&type=script&lang=js&"
export * from "./OccasionFilter.vue?vue&type=script&lang=js&"
import style0 from "./OccasionFilter.vue?vue&type=style&index=0&id=3e493f57&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e493f57",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\Globaltask\\Documents\\Happybox Store\\Happybox Site\\src\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3e493f57')) {
      api.createRecord('3e493f57', component.options)
    } else {
      api.reload('3e493f57', component.options)
    }
    module.hot.accept("./OccasionFilter.vue?vue&type=template&id=3e493f57&scoped=true&", function () {
      api.rerender('3e493f57', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "BuildABox/components/Filters/OccasionFilter.vue"
export default component.exports